import {
  createUserWithEmailAndPassword,
  FacebookAuthProvider,
  GoogleAuthProvider,
  OAuthProvider,
  onAuthStateChanged,
  Persistence,
  sendEmailVerification,
  setPersistence,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import firebase from "../common/firebase";

const auth = firebase.auth();

export const authService = {
  async initializePersistence(persistence) {
    try {
      await setPersistence(auth, persistence);
    } catch (error) {
      console.error("Error setting persistence:", error);
    }
  },

  listenToAuthChanges(cb) {
    onAuthStateChanged(auth, cb);
  },

  getCurrentUser() {
    if (typeof window !== "undefined") {
      return auth.currentUser;
    } else {
      return null;
    }
  },

  async getIdToken() {
    const user = auth.currentUser;
    if (!user) throw new Error("No user is authenticated");
    return await user.getIdToken(true);
  },

  async signInWithEmail(email, password) {
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      return userCredential.user;
    } catch (error) {
      console.error("Error signing in with email:", error);
      throw new Error("Failed to sign in with email");
    }
  },

  async signInWithGoogle() {
    try {
      const provider = new GoogleAuthProvider();
      const userCredential = await signInWithPopup(auth, provider);
      return userCredential.user;
    } catch (error) {
      console.error("Error signing in with Google:", error);
      throw new Error("Failed to sign in with Google");
    }
  },

  async signInWithFacebook() {
    try {
      const provider = new FacebookAuthProvider();
      const userCredential = await signInWithPopup(auth, provider);
      return userCredential.user;
    } catch (error) {
      console.error("Error signing in with Facebook:", error);
      throw new Error("Failed to sign in with Facebook");
    }
  },

  async signInWithApple() {
    try {
      const provider = new OAuthProvider("apple.com");
      const userCredential = await signInWithPopup(auth, provider);
      return userCredential.user;
    } catch (error) {
      console.error("Error signing in with Apple:", error);
      throw new Error("Failed to sign in with Apple");
    }
  },

  async signOutUser() {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Error signing out:", error);
      throw new Error("Failed to sign out");
    }
  },

  async createUserWithEmailAndPassword(email, password) {
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      return userCredential.user;
    } catch (error) {
      console.error("Error creating user with email:", error);
      throw new Error("Failed to create user with email");
    }
  },

  async sendEmailVerificationFb(user) {
    try {
      await sendEmailVerification(user);
    } catch (error) {
      console.error("Error sending email verification:", error);
      throw new Error("Failed to send email verification");
    }
  },
};
